<p-dropdown
  (onChange)="handleDepartmentChange($event)"
  [disabled]="disabled"
  [filter]="true"
  [ngModel]="selectedDepartment"
  [options]="departmentSearchResults"
  dataKey="id"
  filterBy="name"
  optionLabel="name"
  placeholder="Select Department"
  [showClear]="true"
>
  <ng-template pTemplate="selectedItem">
    <div *ngIf="selectedDepartment">
      <img
        [src]="selectedDepartment?.icon?.url"
        class="mr-2"
        style="max-height: 1.2em"
      />{{ selectedDepartment.name }}
    </div>
  </ng-template>
  <ng-template let-department pTemplate="item">
    <div>
      <img
        [src]="department?.icon?.url"
        class="mr-2"
        style="max-height: 1.2em"
      />{{ department.name }}
    </div>
  </ng-template>
</p-dropdown>
